import { FaLinkedin } from "react-icons/fa"
import { FaSquareGithub } from "react-icons/fa6"
import { FaSquareYoutube } from "react-icons/fa6"
import { SiNexusmods } from "react-icons/si"

const data = [
    {id: 1, link: "https://www.linkedin.com/in/thomas-frerichs-a2b487271/", icon: <FaLinkedin />},
    {id: 2, link: "https://github.com/thomasfrer", icon: <FaSquareGithub />},
    {id: 3, link: "https://www.youtube.com/@tornas0322", icon: <FaSquareYoutube />},
    {id: 4, link: "https://next.nexusmods.com/profile/Tornastho/mods", icon: <SiNexusmods />}
]

export default data
